// NOTE use this to show the form's error message (or provide a custom message)
function showFormErrorMessage(form, message) {

  var $output = $('.output', form),
      message = message || 'There was a problem signing you up. Please try again or contact support@theinformation.com for help.';
      
  // reset the form output to its original state
  resetFormOutput($output);

  // update the output text & styles
  $output.html(message).addClass('is-error');
}

// NOTE use this to show the form's success message (or provide a custom message)
function showFormSuccessMessage(form, message) {

  var $output = $('.output', form),
      message = message || 'You have been successfully signed up!';

  // reset the form output to its original state
  resetFormOutput($output);

  // update the output text & styles
  $output.html(message).addClass('is-success');
}

// NOTE use this function to reset a specifc form output
// NOTE pass a jquery node as the $output: resetFormOutput($('.output'))
function resetFormOutput($output) {
  $output.html('').removeClass('is-error is-success');
};
